import { render, staticRenderFns } from "./StatsPanel.vue?vue&type=template&id=1675f2dd&scoped=true&"
import script from "./StatsPanel.vue?vue&type=script&lang=js&"
export * from "./StatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatsPanel.vue?vue&type=style&index=0&id=1675f2dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675f2dd",
  null
  
)

export default component.exports